import {AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { Subscription, Observable } from "rxjs";
import { take } from "rxjs/operators";
import { DefaultTaskTimeOnBoardFilterToggleAction } from "../../../../ngrx/actions/task-filters/default-time-on-board-filter.actions";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../ngrx/state";
import { DaysRange } from "../../../../ngrx/actions/task-filters/task-default-filter.actions";
import { getDefaultTimeOnBoardFilterDaysRange } from "../../../../ngrx/reducers/task-filters/default-time-on-board-filter.reducer";

@Component({
  selector: 'time-on-board-form',
  templateUrl: './time-on-board-form.component.html',
  styleUrls: ['./time-on-board-form.component.scss']
})
export class TimeOnBoardFormComponent implements OnInit, OnDestroy, AfterViewInit {
  @Output() cancel = new EventEmitter();

  @ViewChild('moreThanInput') moreThanInput: ElementRef;
  @ViewChild('lessThanInput') lessThanInput: ElementRef;

  public storeTimeOnBoardFilterValue$: Observable<DaysRange>;

  subs: Subscription[] = [];

  moreThan: number;
  lessThan: number;

  constructor(private _store: Store<AppState>) {}

  ngOnInit() {
    this.storeTimeOnBoardFilterValue$ = this._store.pipe(getDefaultTimeOnBoardFilterDaysRange);
  }

  ngAfterViewInit() {
    this.storeTimeOnBoardFilterValue$.pipe(take(1)).subscribe((daysRange : DaysRange) => {
      this.moreThan = daysRange.moreThan;
      this.lessThan = daysRange.lessThan;
    });
  }

  onSubmit() {
    this._store.dispatch(new DefaultTaskTimeOnBoardFilterToggleAction({
      moreThan: this.moreThan,
      lessThan: this.lessThan
    }));
    this.cancel.emit();
  }

  onCancel() {
    this.cancel.emit();
  }

  ngOnDestroy() {
    this.subs.forEach((sub: Subscription) => sub.unsubscribe());
  }
}
